import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { NerdyTip } from '../NerdyTip';

export type NerdTipProps = StructuredContentDocument<{
  children: Array<StructuredContentDocument>;
}>;

export function NerdTip(props: NerdTipProps) {
  return <NerdyTip {...props} />;
}
